import React from 'react';
import { Hero } from '../components/Hero';
import { Services } from '../components/Services';
import { WhyChooseUs } from '../components/WhyChooseUs';
import { Process } from '../components/Process';
import { Testimonials } from '../components/Testimonials';
import { ServiceAreas } from '../components/ServiceAreas';
import { Contact } from '../components/Contact';
export function Home() {
  return <>
      <Hero data-id="element-280" data-mp="1ziqvdplqi0ms" />
      <Services data-id="element-281" data-mp="1zj8zf8en1j59" />
      <WhyChooseUs data-id="element-282" data-mp="1zjii0axcso0x" />
      <Process data-id="element-283" data-mp="1zkaavdzkg7ni" />
      <Testimonials data-id="element-284" data-mp="24h0mnp4c8h34" />
      <ServiceAreas data-id="element-285" data-mp="24g8u6n61ezh2" />
      <Contact data-id="element-286" data-mp="24htqah802qh1" />
    </>;
}